// extracted by mini-css-extract-plugin
module.exports = {"BreakSpaceLimits":"BreakSpaceLimits_BreakSpaceLimits__UpTmD"};